module.exports = {
    extends: [
        '/',
        'base',
        'modal',
        'modal',
    ],

    handlers: [
        {
            name: 'onSuccessfulLoginDialog',
            async handle(callerComponent){
                if(!this.hasClass('container_base_form_credentials_container')){
                    await this.show(true)
                }
            }
        }
    ]
}
